'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-list', {
      url: '/admin/survey/list',
      template: '<survey-list></survey-list>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/list/survey-list.routes.js